export class LlgResourcePolicy {
    'vaultId';
    'backupRetentionDays';
    'scheduleConfig';
    'cutoffDays';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "HighFrequencyBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "cutoffDays",
            "baseName": "cutoffDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LlgResourcePolicy.attributeTypeMap;
    }
    constructor() {
    }
}
